import React from "react";

type Status = "active" | "inactive" | "draft" | "scheduled" | "ended" | "cancelled" | "at-risk" | "lapsed" | "sent" | "deactivated" | "paused" | "archived" | "expired";

interface StatusBadgeProps {
  status: Status;
}

const statusConfig: Record<Status, { label: string; bg: string; color: string }> = {
  active: { label: "Active", bg: "rgba(48, 164, 108, 0.1)", color: "var(--green, #30A46C)" },
  inactive: { label: "Inactive", bg: "rgba(156, 163, 184, 0.1)", color: "var(--t3, #9CA3B8)" },
  draft: { label: "Draft", bg: "rgba(156, 163, 184, 0.1)", color: "var(--t2, #5A6178)" },
  scheduled: { label: "Scheduled", bg: "rgba(59, 130, 246, 0.1)", color: "#3B82F6" },
  ended: { label: "Ended", bg: "rgba(156, 163, 184, 0.1)", color: "var(--t3, #9CA3B8)" },
  cancelled: { label: "Cancelled", bg: "rgba(229, 72, 77, 0.1)", color: "var(--red, #E5484D)" },
  "at-risk": { label: "At Risk", bg: "rgba(245, 158, 11, 0.1)", color: "var(--orange, #F59E0B)" },
  lapsed: { label: "Lapsed", bg: "rgba(229, 72, 77, 0.1)", color: "var(--red, #E5484D)" },
  sent: { label: "Sent", bg: "rgba(48, 164, 108, 0.1)", color: "var(--green, #30A46C)" },
  deactivated: { label: "Deactivated", bg: "rgba(156, 163, 184, 0.12)", color: "var(--t3, #9CA3B8)" },
  paused: { label: "Paused", bg: "rgba(245, 158, 11, 0.1)", color: "var(--orange, #F59E0B)" },
  archived: { label: "Archived", bg: "rgba(156, 163, 184, 0.08)", color: "var(--t3, #9CA3B8)" },
  expired: { label: "Expired", bg: "rgba(229, 72, 77, 0.08)", color: "var(--red, #E5484D)" },
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const cfg = statusConfig[status];
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "11px", fontWeight: 600, fontFamily: "var(--font-primary, DM Sans, sans-serif)", color: cfg.color, backgroundColor: cfg.bg, padding: "3px 10px", borderRadius: "4px", textTransform: "uppercase" as const, letterSpacing: "0.3px", lineHeight: "16px", whiteSpace: "nowrap" as const }}>
      <span style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: cfg.color, flexShrink: 0 }} />
      {cfg.label}
    </span>
  );
};

export default StatusBadge;
